export default "__VITE_ASSET__0fdf7918__"